import React, { PureComponent, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import SeatListSeat from './SeatListSeat';

import './SeatListRow.scss';

export default class SeatListRow extends PureComponent {
  static propTypes = {
    flightRow: ImmutablePropTypes.mapContains({
      rowNumber: PropTypes.string.isRequired,
      flightSeats: ImmutablePropTypes.listOf(
        ImmutablePropTypes.mapContains({
          available: PropTypes.bool.isRequired,
          flightSeatAttributes: ImmutablePropTypes.listOf(PropTypes.string),
          seatNumber: PropTypes.string,
          flightSeatPrice: ImmutablePropTypes.mapContains({
            webPrice: PropTypes.number.isRequired,
          }),
        }),
      ),
    }),
    onSeatClicked: PropTypes.func.isRequired,
    onHover: PropTypes.func.isRequired,
    direction: PropTypes.string.isRequired,
    paxType: PropTypes.string.isRequired,
    hoveredSeat: PropTypes.string,
  };

  static defaultProps = {
    hoveredSeat: undefined,
  }

  render() {
    const { flightRow, onSeatClicked, direction, paxType, onHover, hoveredSeat } = this.props;
    const numberOfSeats = flightRow.get('flightSeats').size;

    return (
      <div className={`seat-list-row seat-list-row--size-${numberOfSeats}`}>
        {
          flightRow.get('flightSeats').map((seat, index) => (
            <div key={seat.get('seatNumber') || index} className="seat-list-row__seat">
              <SeatListSeat
                onClick={onSeatClicked}
                flightSeat={seat}
                rowNumber={flightRow.get('rowNumber')}
                direction={direction}
                paxType={paxType}
                onHover={onHover}
                isHovered={hoveredSeat === seat.get('seatNumber')}
              />
            </div>
          ))
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatListRow.jsx
 **/